import { mergeStyleSets } from 'office-ui-fabric-react';

export const classNames = mergeStyleSets({
    exampleRoot: {
      marginTop: '20px',
      marginLeft: '20px',
      marginRight: '20px'
    },
    nameText: {
      fontWeight: 'bold'
    }
  });

        
  export const channelStyle = () => {
    const _style =
       {
            marginTop: "1px",
            borderBottom: "1px solid grey"
            
        };
    return _style;
  };

  
